module.exports = __webpack_public_path__ + "static/img/emblem.e715234.png";


//////////////////
// WEBPACK FOOTER
// ./static/emblem.png
// module id = b9K8
// module chunks = 1